export default {
    limitForThisAssembly: 'Nur für diese 3D Gruppe verwenden',
    visibilityFilter: 'Sichtbarkeit',
    placeholderSearch: 'Search',
    teamFilter: 'Teams',
    stateSelect: 'Status',
    minValue: 'Von',
    maxValue: 'Bis',
    search: 'Textsuche',
    placeholder: 'Suchtext eingeben',
    app: 'App',
    webapp: 'Webapp',
    assembly: '3D Gruppe',
    model: '3D Element',
    helper: 'vHelper',
    tbl: 'Tabelle',
    obj: 'Objekt',
    sensor: 'Sensor',
    feed: 'Feed',
    typeSelect: 'Typ',
    tagFilter: 'Tags',
    orgFilter: 'Organisationen',
    fieldSelector: 'Feld filtern',
    all: 'Alle',
    none: 'Keine',
    private: 'Privat',
    public: 'Öffentlich',
    global: 'Global',
    allItemsInSetAreIn: 'Alle Teile von diesen Selection Groups sind bereits im Exportprofil enthalten',
    allItemsAreSet: 'Alle Teile von dieser Selectino Group sind bereits enthalten',
    add: 'Hinzufügen',
    remove: 'Entfernen',
    unmatched: 'Einige Teile sind noch nicht hinzugefügt',
    instancesIn: 'Teile enthalten',
    removeAll: 'Alle Teile entfernen',
    selectionSetFilter: 'Wenn Sie in vSTAGE für dieses 3D Objekt eine Gruppe erstellt haben, können Sie diese hier auswählen und als Filter verwenden.',
    showGlobalProfiles: 'Globale Profile anzeigen',
    executedItems: 'Angwendete Profile',
    noExecutedItems: 'Keine Profile auf dieses Objekt angewendet',
    pivotInfo: 'Ein Pivot markiert den Punkt, um den sich ein Objekt dreht – dies kann bei einer Tür seitlich für das Scharnier oder bei einem Bürostuhl zentriert sein',
    Pivots: 'Drehpunkte',
    EditFilter: 'Administratives bearbeiten',
    showCodeView: 'Code-Ansicht anzeigen',
    limitedToAssembly: 'Für auf diese 3D Gruppe',
    limitedToGlobal: 'Globale Profile',
    selectionSetHint: '(Die Auswahlgruppen werden nur angezeigt, wenn sie in vSTAGE erstellt und zum Modell hochgeladen wurden)',
    create: 'Erstellen',
    filters: 'Filter',
    merge: 'Merge',
    corrections: 'Korrekturen',
    importCSV: 'CSV importieren',
    itemsSelected: 'Elemente ausgewählt',
    pivotPlacement: 'Rotations-Zentrum (pivots)',
    fromSelectionGroups: 'Elemente aus Selection Groups',
    summary: 'Zusammenfassung',
    startSettings: 'Starteinstellungen',
    usedInProjects: 'Verwendet in Projekten',
    reload: 'Neu laden',
    totalTime: 'Gesamtzeit',
    globalExportprofiles: 'Globale Exportprofile',
    localExportprofiles: 'Lokale Exportprofile',
    sourceOriginal: 'Original',
    top: 'Oben',
    bottom: 'Unten',
    left: 'Links',
    right: 'Rechts',
    front: 'Vorne',
    back: 'Hinten',
    center: 'Mitte',
}